import React from 'react';

interface LeadFormFieldsProps {
	formData: Record<string, any>;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	isPhoneRequired?: boolean;
}

const LeadFormFields = ({formData, onChange, isPhoneRequired = false}: LeadFormFieldsProps) => {
	const inputFieldClasses = 'w-full border border-gray-300 rounded-sm py-1 px-2 text-gray-700 focus:outline-hidden focus:ring-2 focus:ring-primary focus:border-transparent';

	return (
		<div className="mb-4 mx-0.5 flex flex-col gap-3">
			<div className="flex flex-row gap-4">
				<div>
					<label htmlFor="firstName" className="text-gray-500 text-xs mb-1">First name</label>
					<input type="text" id="firstName" name="firstName" value={formData?.firstName} onChange={onChange} required className={inputFieldClasses} />
				</div>
				<div>
					<label htmlFor="lastName" className="text-gray-500 text-xs mb-1">Last name</label>
					<input type="text" id="lastName" name="lastName" value={formData?.lastName} onChange={onChange} required className={inputFieldClasses} />
				</div>
			</div>
			<div>
				<label htmlFor="phone" className="text-gray-500 text-xs mb-1">Phone {isPhoneRequired ? '' : '(optional)'}</label>
				<input type="tel" id="phone" name="phone" value={formData?.phone} onChange={onChange} required={isPhoneRequired} className={inputFieldClasses} />
			</div>
			<div>
				<label htmlFor="email" className="text-gray-500 text-xs mb-1">Email</label>
				<input type="email" id="email" name="email" value={formData?.email} onChange={onChange} required className={inputFieldClasses} />
			</div>
		</div>
	);
};

export default LeadFormFields;
